// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { TargetTrackPoint, ITargetTrackPoint } from "./TargetTrackPoint.gen";
import { TargetType } from "./Shared.TargetType.gen";

export interface ITargetTrack {
	targetId: string | undefined;

	externalId: string | undefined;

	deviceId: string | undefined;

	type: TargetType;

	lastUpdate: string | undefined;

	points: ITargetTrackPoint[] | undefined;

	$type?: string | undefined;
}
export class TargetTrack {
	constructor(data?: ITargetTrack) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.lastUpdate) { this.lastUpdate = new Date(data.lastUpdate); }
		this.points = data.points ? data.points.map((p: any) => new TargetTrackPoint(p)) : [];
	}

	targetId: string | undefined;

	externalId: string | undefined;

	deviceId: string | undefined;

	type: TargetType = 0;

	lastUpdate: Date | undefined = new Date();

	points: TargetTrackPoint[] | undefined = [];

	static $type: string = "CoreApi.Models.TargetTrack, ";
	$type?: string | undefined = TargetTrack.$type;
}

